import React from "react";

const iconLink =
  "inline-flex items-center justify-center w-8 h-8 rounded-md text-gray-500 hover:text-[#064E8D] hover:bg-gray-100 transition-colors no-underline";
const iconMuted =
  "inline-flex items-center justify-center w-8 h-8 rounded-md text-gray-500 hover:text-green-700 hover:bg-green-50 transition-colors";

/** Actions for inactive users in a DataTables-mounted React root (no Router context). */
const FreightInactiveUserDtActions = ({ row, onReactivate, getNavigate }) => {
  const id = row?.id;
  if (id == null) return null;

  const go = (path) => {
    const nav = getNavigate?.();
    if (typeof nav === "function") {
      nav(path);
      return;
    }
    window.location.assign(path);
  };

  return (
    <div className="flex items-center justify-center gap-0.5 flex-wrap">
      <a
        href={`/freight/active_users/${id}/edit`}
        className={iconLink}
        title="Edit user"
        onClick={(e) => {
          e.preventDefault();
          go(`/freight/active_users/${id}/edit`);
        }}
      >
        <i className="fas fa-pen text-sm" aria-hidden />
      </a>
      <button
        type="button"
        className={iconMuted}
        title="Re-activate user"
        onClick={() => onReactivate?.(id)}
      >
        <i className="fas fa-user-check text-sm" aria-hidden />
      </button>
    </div>
  );
};

export default FreightInactiveUserDtActions;
